import { deepClean, encodeQueryData } from "@/utils/commonUtils";

export const buildQueryPath = (path, query = {}) => {
    const params = encodeQueryData(deepClean(query || {}));
    return params ? `${path}?${params}` : path;
};

export const getWithQuery = (httpService, path, query = {}) => {
    return httpService.get(buildQueryPath(path, query));
};

export const assertRequired = (value, message) => {
    if (value == null || value === "") {
        throw new Error(message);
    }
};
